import { render, staticRenderFns } from "./GGToolbar.vue?vue&type=template&id=346bc082&"
import script from "./GGToolbar.vue?vue&type=script&lang=js&"
export * from "./GGToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('346bc082')) {
      api.createRecord('346bc082', component.options)
    } else {
      api.reload('346bc082', component.options)
    }
    module.hot.accept("./GGToolbar.vue?vue&type=template&id=346bc082&", function () {
      api.rerender('346bc082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/GGToolbar.vue"
export default component.exports